import { HTMLProps, forwardRef } from 'react';

export type SidebarSectionContentProps = HTMLProps<HTMLDivElement>;

const SidebarSectionContent = forwardRef<
  HTMLDivElement,
  SidebarSectionContentProps
>((props, ref) => {
  const { className, children, ...rest } = props;

  return (
    <div ref={ref} className={className} {...rest}>
      {children}
    </div>
  );
});

SidebarSectionContent.displayName = 'SidebarSection.Content';

export default SidebarSectionContent;
